import { CircularProgress } from "@mui/material";
import { useState } from "react";
import { getDocument } from "../../services/getDocument";
import { MixpanelWrapper } from "../MixPanelWrapper";
import DownloadIcon from '@mui/icons-material/Download';
import { DocumentType } from '../../helper/enum/DocumentType'
import { getWording } from "../../services/getWording";
import { colours } from '../../shared/colors';
import { FileDownloadOff } from "@mui/icons-material";

/**
 * Component for downloading a specific type of document associated with a quote.
 *
 * This component displays an icon that, when clicked, initiates the download of a specific type of document,
 * such as an insurance certificate or policy schedule, associated with a quote.
 *
 * @param {Object} props - The props passed to the component.
 * @param {string} props.type - The type of document to download (e.g., "insuranceCertificate" or "policySchedule" or "quoteDocument").
 * @param {string} props.quoteDataId - The ID of the quote data associated with the document.
 * @param {boolean} props.disabled - whether to disable the button
 * @returns {JSX.Element} The rendered component for downloading a specific document.
 */
const DocumentDownload = ({
	quoteDataId,
	type,
	wording,
	disabled = false,
}: {
	quoteDataId: number;
	type: DocumentType;
	wording?: any;
	disabled?: boolean;
}) => {
	const [loading, setLoading] = useState(false);

	/**
	 * Downloads the specific type of document associated with the quote.
	 */
	const downloadDocument = async () => {
		setLoading(true);

		MixpanelWrapper.track("Open Quote", {
			Document: type,
		});

		try {
			if (type == DocumentType.Wording){
				await getWording(quoteDataId, wording.policyWordingUrl, wording.policyWordingName, true);
			}
			else{
				await getDocument(quoteDataId, type, true);
			}
		} catch (error) {
			console.log(error);
		}

		setLoading(false);
	};

	return (
		loading ? (
			<CircularProgress
				size={20}
				sx={{
					color: "black",
				}}
			/>
		) : disabled ? (
			<FileDownloadOff 
				sx={{ cursor: 'not-allowed', color: colours.disabled.main }}
			/>
		) : (
			<DownloadIcon 
				onClick={downloadDocument} 
				sx={{ cursor: 'pointer', color: colours.primary.main}}
			/>
		)
	);
};

export default DocumentDownload;
